import React from "react";
import PropTypes from "prop-types";

export const Link = ({
  href,
  className,
  onClick,
  text,
  children,
  ariaLabel,
  ...rest
}) => {
  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      {...rest}
    >
      {text}
      {children}
    </a>
  );
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  ariaLabel: PropTypes.string
};

Link.defaultProps = {
  className: "link",
  text: ""
};
